<template>
  <div class="products-kld-page-content flex flex-col items-center w-full text-left">
    <!-- banner 包含移动端 -->
    <PageBanner class="max-ml:hidden!" :content="content.bannerInfo" />

    <PageBusinessRow :content="content.businessIntroduction">
      <template #left>
        <!-- 只替换左侧内容，右侧仍显示原图片 -->
        <p class="text-[#616671] text-[1rem] mb-[3rem] w-32.5rem max-ml:w-100%"
          v-for="desc in content.businessIntroduction.description">{{
            desc }}</p>

        <div class="flex justify-between text-center w-32.5rem max-ml:w-100%">
          <div class="flex flex-col text" v-for="extraDesc in content.businessIntroduction.extraDesData">
            <span class="text-1.63rem text-#272E3B mb-0.5rem font-800">{{ extraDesc.title }}</span>
            <span class="text-#616671 text-1.1rem">{{ extraDesc.desc }}</span>
          </div>
        </div>
      </template>
    </PageBusinessRow>

    <!-- 产品功能介绍 中间左右布局的内容 -->
    <PageFunction :content="content.featuresIntroduction" />

    <!-- 产品优势 -->
    <PageAdvantage :content="content.advantage" :extraTitleStyle="{ color: '#272E3B' }" />

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '快乐达'
const description = '线上下单  即时配送'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  bannerInfo: {
    banner: '/images/pages/products/kld/banner-0.png',
    mobileBanner: '/images/mobile/products/kld.png'
  },
  businessIntroduction: {
    title: '产品业务介绍',
    description: [
      '和贵科技于2021年10月独立研发上线的即时零售平台，该项目业务、系统、组织已形成高效、标准化的流程规范。目前口味王集团通过该平台已在全国超100+市场开展业务，每年更是通过该系统实现单品营业额超3亿+。平台用户数达700w+。目前已在华南、华中的大部分城区开通服务，涵盖广州、深圳、长沙、武汉、岳阳、株洲、衡阳、娄底、益阳。',
    ],
    extraDesData: [
      {
        title: '100+',
        desc: '市场开展业务',
      }, {
        title: '3亿+',
        desc: '单品营业额',
      }, {
        title: '700w+',
        desc: '平台用户数',
      },
    ],
    descImage: '/images/pages/products/kld/vector-0.png',
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    extraCardBackColor: 'bg-#FFFBF7',
    extraTitleClass: 'bg-#FFFBF7 w-100%!',
    groups: [
      {
        title: '供应链',
        desc: '',
        descList: [
          '从仓库-配送员-用户实现订单的人流-物流-信息流-资金流的链条流转以及追踪',
        ],
        icon: '/images/pages/products/kld/f-i- (1).png',
        mainImage: '/images/pages/products/kld/f- (1).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '营销活动',
        desc: '',
        descList: ['可针对标签人群实现自动化营销，优惠券与积分调动用户积极性，提高用户转化率以及复购率',],
        icon: '/images/pages/products/kld/f-i- (2).png',
        mainImage: '/images/pages/products/kld/f- (2).png',
        direction: 'copywriting-to-image'
      },
      {
        title: 'BI数据平台',
        desc: '',
        descList: ['完整的数据分析平台为运营人员提供充足的数据支撑，提高运营决策效率'],
        icon: '/images/pages/products/kld/f-i- (3)-.png',
        mainImage: '/images/pages/products/kld/f- (3).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '独立配送端',
        desc: '',
        descList: ['即时方便的接单和查看任务清单和收益；系统通过灵活用工为配送支付配送费和其他收益',],
        icon: '/images/pages/products/kld/f-i- (4).png',
        mainImage: '/images/pages/products/kld/f- (4).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '考勤',
        desc: '',
        descList: ['拥有平台配送员完整的排班考勤奖惩机制，帮助市场经理更好的管理配送员出勤与业绩',],
        icon: '/images/pages/products/kld/f-i- (5).png',
        mainImage: '/images/pages/products/kld/f- (5).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '财务中心',
        desc: '',
        descList: ['资金对账以及供应商货款管理保障每一笔交易有迹可循；配送员收益与奖惩为配送员奖惩核算提供依据',],
        icon: '/images/pages/products/kld/f-i- (6).png',
        mainImage: '/images/pages/products/kld/f- (6).png',
        direction: 'copywriting-to-image'
      }, {
        title: '调度中心',
        desc: '',
        descList: ['分不同商圈电子围栏的自动调度和手工调度',],
        icon: '/images/pages/products/kld/f-i- (7).png',
        mainImage: '/images/pages/products/kld/f- (7).png',
        direction: 'image-to-copywriting'
      }, {
        title: '客服中心',
        desc: '',
        descList: ['客服可以针对不同的坐席，提高回复效率和处理时长'],
        icon: '/images/pages/products/kld/f-i- (8).png',
        mainImage: '/images/pages/products/kld/f- (8).png',
        direction: 'copywriting-to-image'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    background: '/images/pages/products/kld/b-back.png',
    list: [
      {
        briefBack: '/images/pages/products/kld/b- (3).png',
      },
      {
        briefBack: '/images/pages/products/kld/b- (1).png',
      },
      {
        briefBack: '/images/pages/products/kld/b- (2).png',
      },

    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-kld-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .kld-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/kld/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 5px;
        left: 0;
        width: 19px;
        height: 19px;
        background-image: url("/images/pages/products/kld/圆点.png");
        background-size: cover;
        content: "";
      }
    }
  }
}

.kld-product-advantage {
  background-image: url("/images/pages/products/kld/product_bottom_next.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
